module.exports = __webpack_public_path__ + "img/play-button.a083bbfb.svg";